<template>
    <div>
        <div class="header">
            <div class="top w flex just-between align-center">
                <div class="top-list flex align-center">
                    <div class="pointer" @click.prevent="goHome">
                        <img class="logo m-r-25 m-b-10 pointer" src="/image/img/logo.png" alt="">
                        <div class="font-16" style="color: #949494;letter-spacing: 1px">全屋智能家居系统全球第一品牌</div>
                    </div>
                    <!-- <div class="list flex just-around pointer" :class="{'active': current == 1}" @click="changeShow()">
                        商品分类
                        <img class="first-img" :class="{'first-img-active': show}" src="/image/img/down.png" alt="">
                    </div>
                    <div class="list pointer" v-for="(item, index) in navList" :key="index" :class="{'active': current == index + 2}" @click="customizedClick(index, item)">
                        {{item.name}}
                    </div> -->
                </div>
                <div class="search-con flex just-between align-center">
                    <div class="search-left">
                        <el-input @keyup.enter.native="goGoodsListPage(searchInfo)" class="search-input" v-model="searchInfo" id="search-input" placeholder="搜索商品..."></el-input>
                        <i @click="goGoodsListPage(searchInfo)" class="fa el-icon-search pointer"></i>
                    </div>
                    <div class="search-right flex align-center pointer" @click.stop="loadPage('activity-list', {condition: true})">
                        <img class="shopping-cart" src="/image/img/cate_list.png" alt="">
                        <!-- <img class="shopping-cart" src="/static/cate_list.png" alt=""> -->
                        产品分类
                    </div>
                    <div class="search-right flex align-center pointer" @click.stop="loadPage('user-cart')">
                        <img class="shopping-cart" src="/image/img/shopping-cart.png" alt="">
                        购物车
                        <div class="cart-num">{{allCartLength > 100 ? '99+' : (allCartLength || 0)}}</div>
                    </div>
                </div>
            </div>
            <!-- <div class="commodity">
                <el-collapse-transition>
                    <div class="w flex pointer" v-show="show">
                        <div class="left top-scroll">
                            <div class="title flex just-between" :class="{'active': selected === index}" v-for="(list, index) in productData" :key="index" @click="categoryClick(false, list.tagResponse)" @mouseenter="mouseEnter(list, index)">
                                <span>{{list.title}}</span>
                                <i class="el-icon-arrow-right"></i>
                            </div>
                        </div>
                        <div class="right">
                            <div class="product-list" v-loading="loading">
                                <div v-if="goodsList.length > 0">
                                    <div class="product-title m-b-20">
                                        <a class="active p-0-30" @click.stop="categoryClick(true)" target="_blank">查看所有<i class="el-icon-arrow-right"></i></a>
                                    </div>
                                    <div class="flex align-center text-center">
                                        <div class="link-black header-card" v-for="(list, index) in goodsList" :key="index" @click="goDetailPage(list)">
                                            <img class="thumbnail" :title="list.goodsName" v-lazy="list.img" :alt="list.goodsName">
                                            <div class="two-overflow" :title="list.goodsName">{{list.goodsName}}</div>
                                        </div>
                                    </div>
                                </div>
                                <div v-else>
                                    <img style="margin: auto;" src="/image/img/empty.png">
                                    <p class="font-18 text-center m-t-20">暂无数据</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </el-collapse-transition>
            </div> -->
        </div>
    </div>
</template>
<script type="text/ecmascript-6">
    export default {
        data() {
            return {
                searchInfo: '',
                showNav: false,
            }
        },
        computed: {
            allCartLength() {
                return this.$store.getters.getAllCartLength
            }
        },
        methods: {
            goGoodsListPage(keyword) {
                let param = {}
                param.keyword = keyword
                param.searchTitle = keyword
                param.condition = true
                param.condition = false
                if (this.$route.name === 'activity-list') {
                    this.loadPage('activity-list', param)
                    this.$pcBus.$emit('searchProduct')
                } else {
                    this.loadPage('activity-list', param)
                }
            }
        }
    }
</script>
<style>
    /* 通用头部导航 */
    .header .top{
        height: 130px;
    }
    .header .top .top-list{
        height: 100%;
    }
    .header .top .top-list .list{
        width: 80px;
        height: 67px;
        margin: 0 10px;
        text-align: center;
        font-size: 14px;
        font-weight: 400;
        color: #3B3E40;
        line-height: 67px;
        box-sizing: border-box;
    }
    .header .top .top-list .list img{
        width: 16px;
    }
    .header .search-con .search-left,
    .header .search-con .search-right{
        background: #f8f9fa;
        border-radius: 40px;
        margin-right: 20px;
    }
    .header .search-con .search-right{
        padding: 0 20px;
        font-size: 15px;
        height: 58px;
        color: #757575;
    }
    .header .search-con .search-right .shopping-cart{
        width: 23px;
        height: 23px;
        display: inline;
        margin: 0 10px 0 0;
    }
    .header .search-con .search-right .cart-num{
        min-width: 23px;
        height: 23px;
        border-radius: 50%;
        background: #a50082;
        color: #ffffff;
        text-align: center;
        line-height: 23px;
        margin-left: 10px;
        font-size: 13px;
    }
    .header .search-con .search-left .search-input{
        width: 450px;
        height: 58px;
        line-height: 58px;
        padding-left: 10px;
        font-size: 15px;
        outline: none;
        margin-right: -2px;
    }
    .header .search-con .el-input__inner{
        background-color: #f8f9fa;
    }
    .header .search-con .el-input__inner::placeholder{
        color: #757575;
    }
    .header .search-con .fa{
        font-size: 20px;
        margin: 12px;
        margin-right: 20px;
    }
    .header .search-con .search-input input{
        border: none!important;
        height: 38px;
        outline: none;
    }
    .first-img{
        width: 16px;
        height: 16px;
        margin: auto;
        transition: all 0.3s linear;
    }
    .first-img-active{
        transform: rotate(180deg);
    }
    .header .top .top-list .active{
        color: #BC5BA7;
    }

    /* 面包屑导航 */
    .crumb{
        line-height: 50px;
        color: #888;
        font-size: 14px;
    }

    .commodity{
        position: absolute;
        top: 68px;
        width: 100%;
        z-index: 1000;
        background: #ffffff;
        box-shadow: 0px 6px 10px 0px rgba(1, 1, 1, 0.09);
    }
    .commodity .w{
        padding: 30px 0 20px;
    }
    .commodity .w .left{
        padding-left: 200px;
        flex: 0 0 200px;
    }
    .commodity .w .left .title{
        font-size: 14px;
        font-weight: 400;
        color: #3B3E40;
        line-height: 20px;
        padding-bottom: 20px;
    }
    .commodity .active{
        color: #BC5BA7 !important;
    }
    .commodity .w .left .title i{
        margin-left: 100px;
    }
    .commodity .w .right{
        padding: 0 60px;
        flex: 0 0 800px;
        font-size: 14px;
    }
    .commodity .w .right .product-list{
        padding-bottom: 60px;
        background: #ffffff;
    }
    .commodity .w .right .product-list .product-title{
        font-size: 15px;
        font-weight: 400;
        color: #333333;
        line-height: 20px;
    }
    .commodity .w .right .thumbnail{
        width: 100px;
        height: 100px;
        margin: auto;
        margin-bottom: 10px;
    }
    .commodity .w .right .thumbnail+div{
        width: 100px;
        margin: auto;
    }
    .commodity .w .p-0-30{
        padding: 0 30px;
    }
    .header-card{
        flex: 0 0 17.5%;
        margin-right: 1%;
    }
    .header-card:nth-child(5n){
        margin-right: 0;
    }
    .commodity .top-scroll{
        height: 304px;
        overflow-y: scroll;
    }
    .commodity .top-scroll::-webkit-scrollbar {
        display: none;
    }
</style>



// WEBPACK FOOTER //
// src/components/layout/header/index.vue